import React from 'react';
import Typography from '../Text/Typography';
import Icon from '../Icon/Icon';
import Tag from '../Tag/Tag';
import './SearchCard.css';

// Import placeholder images for custom routines
import postExerciseImage from '../../assets/postexercise.png';
import backFromWorkImage from '../../assets/backfromwork.png';
import beachDayImage from '../../assets/beachday.png';
import afterNightOutImage from '../../assets/afternightout.png';

interface SearchCardProps {
  product: {
    product_id: number;
    product_name: string;
    brand: string;
    category: string;
    image_url?: string;
  };
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
}

const capitalizeWords = (str: string) => {
  return str.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const SearchCard: React.FC<SearchCardProps> = ({
  product,
  isSelected = false,
  onClick,
  className = '',
}) => {
  // Get placeholder image for custom routines based on product name
  const getCustomRoutineImage = () => {
    if (product.brand !== 'Custom Routine') return null;
    
    const imageMap: { [key: string]: string } = {
      'Post-Exercise': postExerciseImage,
      'Back from Work': backFromWorkImage,
      'Beach Day': beachDayImage,
      'After a Night Out': afterNightOutImage
    };
    
    return imageMap[product.product_name] || null;
  };

  const customRoutineImage = getCustomRoutineImage();

  return (
    <div
      className={`search-card ${isSelected ? 'selected' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="search-card-image-container">
        {product.image_url ? (
          <img 
            src={product.image_url} 
            alt={product.product_name} 
            className="search-card-image" 
          />
        ) : customRoutineImage ? (
          <img 
            src={customRoutineImage} 
            alt={product.product_name} 
            className="search-card-image" 
          />
        ) : (
          <div className="search-card-image-placeholder">
            <Icon name="book" size="large" />
          </div>
        )}
      </div>
      <div className="search-card-info">
        <Typography variant="body-small" className="search-card-company">
          {product.brand}
        </Typography>
        <Typography variant="body-bold" className="search-card-name">
          {product.product_name}
        </Typography>
        <Tag className="search-card-category">
          {capitalizeWords(product.category)}
        </Tag>
      </div>
    </div>
  );
};

export default SearchCard;
